var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vote" },
    [
      _c("secTitle"),
      _vm._v(" "),
      _vm.loadingToken ? _c("loading", { staticClass: "loading" }) : _vm._e(),
      _vm._v(" "),
      !_vm.loadingToken
        ? _c(
            "section",
            [
              _c("div", { staticClass: "__second-title no-top" }, [
                _vm._v(_vm._s(_vm.$t("walletVote.section1.title")))
              ]),
              _vm._v(" "),
              _c(
                "wallet-table",
                {
                  staticClass: "wallet-vote-table",
                  attrs: {
                    headList: _vm.voteHeadList,
                    contentList: _vm.voteList
                  }
                },
                [
                  _vm._l(_vm.voteList, function(v, i) {
                    return _c(
                      "span",
                      {
                        key: i,
                        attrs: { slot: i + "nodeStatusTextAfter" },
                        slot: i + "nodeStatusTextAfter"
                      },
                      [
                        v.nodeStatus === 2
                          ? _c(
                              "i",
                              {
                                staticClass: "tipsicon hoveraction",
                                on: {
                                  click: function($event) {
                                    if (
                                      $event.target !== $event.currentTarget
                                    ) {
                                      return null
                                    }
                                    $event.stopPropagation()
                                    return _vm.toggleTips($event)
                                  }
                                }
                              },
                              [
                                _vm.isResisterTipsShow
                                  ? _c("tooltips", {
                                      directives: [
                                        {
                                          name: "click-outside",
                                          rawName: "v-click-outside",
                                          value: _vm.hideTips,
                                          expression: "hideTips"
                                        }
                                      ],
                                      staticClass: "unregister-tips",
                                      attrs: {
                                        content: _vm.$t(
                                          "walletVote.section1.hoverHelp",
                                          { nodeName: v.nodeName }
                                        )
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.voteList, function(v, i) {
                    return _c(
                      "span",
                      {
                        key: i,
                        class: _vm.cache ? "unclickable" : "clickable",
                        attrs: { slot: i + "operateKeyBefore" },
                        slot: i + "operateKeyBefore"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "operate-btn",
                            on: {
                              click: function($event) {
                                return _vm._cancelVote(v)
                              }
                            }
                          },
                          [_vm._v(_vm._s(v.operate))]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "operate-btn",
                            on: {
                              click: function($event) {
                                return _vm.openReward(v)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("walletVote.toReward")))]
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.loadingToken
        ? _c(
            "section",
            { staticClass: "node_list" },
            [
              _c(
                "div",
                { staticClass: "__second-title" },
                [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("walletVote.section2.title")))
                  ]),
                  _vm._v(" "),
                  _c("search", {
                    attrs: { placeholder: _vm.$t("walletVote.search") },
                    model: {
                      value: _vm.filterKey,
                      callback: function($$v) {
                        _vm.filterKey = $$v
                      },
                      expression: "filterKey"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "wallet-table",
                {
                  staticClass: "wallet-vote-table node-list",
                  attrs: {
                    clickCell: _vm.clickCell,
                    noDataText: _vm.nodeNoDataText,
                    headList: _vm.nodeHeadList,
                    contentList: _vm.nodeList
                  }
                },
                [
                  _vm._l(_vm.nodeList, function(item, i) {
                    return _c(
                      "span",
                      {
                        key: i,
                        staticClass: "rank",
                        attrs: { slot: i + "rankBefore" },
                        slot: i + "rankBefore"
                      },
                      [_vm._v(_vm._s(i + 1))]
                    )
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.nodeList, function(v, i) {
                    return _c(
                      "span",
                      {
                        key: i,
                        attrs: { slot: i + "operateKeyBefore" },
                        on: {
                          click: function($event) {
                            return _vm._vote(v)
                          }
                        },
                        slot: i + "operateKeyBefore"
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(v.operate) +
                            "\n            "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }